// extracted by extract-css-chunks-webpack-plugin
module.exports = {"LTOBanner":"_7_Valj","ribbon":"_3RsFv1","absolutePos":"M1_Ggy","text":"_3LVUg5","adbugContainer":"_2g7Ug6","adbug":"YOEb22"};